import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../BaseUrlConfigration/ApiConfig";

export const createColorGroupAction = createAsyncThunk(
  "colorGroup/create",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.post("/color-group/create", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const getColorGroupCategoriesAction = createAsyncThunk(
  "colorGroup/categories",
  async (groups, thunkAPI) => {
    try {
      const groupParam = Array.isArray(groups)
        ? groups.filter((g) => g !== "all").join(",")
        : groups;
      const response = await Api.get(
        `/color-group/categories?groups=${encodeURIComponent(groupParam)}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const listColorGroupAction = createAsyncThunk(
  "colorGroup/list",
  async (reqBody, thunkAPI) => {
    try {
      const search = reqBody?.searchValue !== undefined ? reqBody.searchValue : reqBody?.search || "";
      const page = reqBody?.page !== undefined ? reqBody.page : 0;
      const limit = reqBody?.limit !== undefined ? reqBody.limit : 20;
      let url = `/color-group/list?search=${encodeURIComponent(search)}&page=${page}&limit=${limit}`;
      if (reqBody?.group !== undefined && reqBody?.group !== "" && reqBody?.group !== null) {
        url += `&group=${encodeURIComponent(reqBody.group)}`;
      }
      if (reqBody?.sortKey) {
        url += `&sortKey=${encodeURIComponent(reqBody.sortKey)}`;
      }
      if (reqBody?.sortOrder) {
        url += `&sortOrder=${encodeURIComponent(reqBody.sortOrder)}`;
      }
      const response = await Api.get(url);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const updateColorGroupAction = createAsyncThunk(
  "colorGroup/update",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.put("/color-group/update", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const deleteColorGroupAction = createAsyncThunk(
  "colorGroup/delete",
  async (reqBody, thunkAPI) => {
    try {
      const id =
        typeof reqBody === "object" && reqBody?.id ? reqBody.id : reqBody;
      const response = await Api.delete(`/color-group/delete?id=${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const getColorGroupByIdAction = createAsyncThunk(
  "colorGroup/getById",
  async (id, thunkAPI) => {
    try {
      const groupId = typeof id === "object" && id?.id ? id.id : id;
      const response = await Api.get(`/color-group/${groupId}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);



